import React, { useState } from 'react';

import { Card, CircularProgress } from '@material-ui/core';
import { redeemVoucherApi } from 'api/meshStore';
import MeshDropdown from 'components/MeshDropdown';
import { useSelector, useDispatch } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import styled, { css } from 'styled-components';
import { StyledTypography, StyledButton } from 'styles/common';

import { MoolahIcon } from 'constants/icons';

import { showSuccessSnackbar, showErrorSnackbar } from 'services/snackbar';

const dropdownStyles = css`
  .MuiSelect-iconOutlined {
    right: 3px;
  }
  fieldset {
    border: 0;
  }
  .MuiSelect-root {
    padding-left: 0;
  }
`;

export default function VoucherCard({ src, id, name, redeemed = false, denominations = [] }) {
  const [redeeming, setRedeeming] = useState(false);
  const [selectedDenomination, setSelectedDenomination] = useState(
    denominations[0] ? denominations[0].convertedValue : 0
  );
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);
  const dispatch = useDispatch();

  function getSelectedDenominationObject() {
    return denominations.filter((d) => d.convertedValue === selectedDenomination);
  }

  function onRedeemClick() {
    setRedeeming(true);
    const denomination = getSelectedDenominationObject();
    redeemVoucherApi({
      employeeId: loggedInEmployeeId,
      voucherId: id,
      denominationMap: denomination[0],
    })
      .then((res) => dispatch(showSuccessSnackbar('Redemtion request has been successfully registered. ')))
      .catch((err) => dispatch(showErrorSnackbar('An error occured while redeeming voucher')))
      .finally(setRedeeming(false));
  }

  const selectedDenominationObject = getSelectedDenominationObject();

  return (
    <Container>
      <SubContainer>
        <LogoContainer>
          <LogoImage src={src} />
        </LogoContainer>
        <DetailsContainer>
          <IconAndDropdownContainer>
            <MoolahIcon size="smallest" rightGutter={1} />
            <MeshDropdown
              menuId={`moneyMenu${src}`}
              menuItems={denominations}
              displayKey="money"
              valueKey="convertedValue"
              selected={selectedDenomination}
              onChange={(value) => {
                setSelectedDenomination(value);
              }}
              cssStyles={dropdownStyles}
            />
          </IconAndDropdownContainer>
          {/* <IconDropdown
            menuItems={[{ content: 500 }, { content: 600 }]}
            icon={<StyledTypography weight={600}>{money} Money</StyledTypography>}
          /> */}

          <StyledTypography weight={600}>₹{selectedDenomination}</StyledTypography>
        </DetailsContainer>
        <StyledButton
          onClick={onRedeemClick}
          disabled={!(selectedDenominationObject && selectedDenominationObject.redeemable)}
          variant="contained"
          color="primary"
        >
          {redeeming ? <CircularProgress size="small" /> : 'Redeem'}
        </StyledButton>
      </SubContainer>
    </Container>
  );
}

const Container = styled(Card)`
  display: flex;
  justify-content: center;
  padding: 1rem 2rem 1.5rem 2rem;
`;

const SubContainer = styled.div`
  width: 60%;
  text-align: center;
`;

const LogoContainer = styled.div`
  height: 80px;
  width: 80%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 0.5rem;
`;

const LogoImage = styled.img`
  max-width: 100%;
  max-height: 100px;
`;

const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  align-items: center;
`;

const IconAndDropdownContainer = styled.div`
  display: flex;
  align-items: center;
`;
